import { create } from 'zustand';

import type { EntityType } from '../../data-contract/chat';

export type EntityCreation = {
    readonly architectureId: string | null;
    readonly createdAt: number;
    readonly type: EntityType;
};

type EntityCreationState = {
    /** Agent creations seen this session, pruned shortly after arrival. */
    readonly creations: readonly EntityCreation[];
    readonly recordedEventIds: ReadonlySet<string>;
    readonly recordEntityCreations: (eventId: string, creations: readonly EntityCreation[]) => void;
};

// Entries exist only so a mounted surface can react to what the agent just made,
// so they are dropped aggressively rather than kept for the session.
const PRUNE_AFTER_MS = 30_000;

export const useEntityCreationStore = create<EntityCreationState>((set) => ({
    creations: [],
    recordedEventIds: new Set(),
    recordEntityCreations: (eventId, creations) =>
        set((state) => {
            if (state.recordedEventIds.has(eventId) || creations.length === 0) {
                return state;
            }
            const now = Date.now();

            return {
                creations: [
                    ...state.creations.filter((creation) => now - creation.createdAt < PRUNE_AFTER_MS),
                    ...creations,
                ],
                recordedEventIds: new Set([...state.recordedEventIds, eventId]),
            };
        }),
}));

export const recordEntityCreations = (eventId: string, creations: readonly EntityCreation[]): void => {
    useEntityCreationStore.getState().recordEntityCreations(eventId, creations);
};
